import React, { memo } from 'react';
import FormControlLabel from '../FormControlLabel';
export var FormControlOptionLabel = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(FormControlLabel, props);
});
FormControlOptionLabel.defaultProps = {
  labelPlacement: 'end',
  variant: 'body2'
};
export default FormControlOptionLabel;